var _circle, _circle2, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesThree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "url(#paint0_linear_1486_2097)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 23,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 23.5654C37 22.8599 36.5822 22.217 35.9422 21.9312L29.72 19.154C29.2578 18.9487 28.7333 18.9487 28.28 19.154L22.0578 21.9312C21.4178 22.217 21 22.8599 21 23.5654V27.7624C21 32.7185 24.4133 37.3531 29 38.4783C30.9205 38.0085 32.6292 36.9241 33.9714 35.4545L33.9855 35.4638C33.9855 35.4638 34.0808 35.3471 34.2134 35.1809L34.2267 35.1653L34.2262 35.1648C34.3991 34.9477 34.6301 34.6525 34.7971 34.4203C34.8884 34.2934 34.981 34.1898 35.0684 34.092C35.2547 33.8835 35.4173 33.7016 35.4928 33.3768L35.4974 33.3555C36.4483 31.682 37 29.7496 37 27.7624V23.5654Z",
    fill: "url(#paint1_linear_1486_2097)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1486_2097",
    x1: 29,
    y1: 118.484,
    x2: 29,
    y2: -14.9677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF9C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#9D3CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1737E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1486_2097",
    x1: 29,
    y1: 58.7907,
    x2: 29,
    y2: 13.9734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF9C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#9D3CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1737E5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesThree);
export default __webpack_public_path__ + "static/media/featuresThree.9298a44317c56ee3d11eea75744a746c.svg";
export { ForwardRef as ReactComponent };